import React from 'react';
import { Link } from 'react-router-dom';

import PublicStore from 'Site/State/Store';

class NavList extends React.Component {
  constructor (props) {
    super(props);
    const { pages } = PublicStore.getState();
    this.state = { pages };
    this.makePageLink = this.makePageLink.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = PublicStore.subscribe(() => {
      const { pages } = PublicStore.getState();
      this.setState({ pages });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  makePageLink ({ url, name, shy, external }) {
    const { location } = this.props;
    const isActivePage = location && ('/' + url) === location.pathname;
    const className = isActivePage ? 'active' : '';
    return (external
      ? <a href={url} key={url} target="_blank" className={className}>{name}</a>
      : <Link to={'/' + url} key={url} className={className}>{name}</Link>
    );
  }

  render () {
    const { pages } = this.state;
    let { className, showAll } = this.props;
    className = 'NavList' + (className ? ' ' + className : '');
    const list = pages
      .filter(page => !page.hidden && (showAll ? true : !page.shy))
      .map(this.makePageLink);

    return (
      <div className={className}>{list}</div>
    );
  }
};

export default NavList;



// WEBPACK FOOTER //
// ./client/Site/Ui/NavList.jsx